module.exports = __webpack_public_path__ + "static/media/clubs.f32fa8bc.svg";